/**
 * Invites API
 *
 * API functions for the email invite flow (FLOW-630).
 */

import { api } from "./client";
import type {
  InvitePreview,
  InviteResponse,
  PendingInviteListResponse,
  ProjectId,
  SendInviteRequest,
} from "./types";

export async function getInvite(token: string): Promise<InvitePreview> {
  return api.get<InvitePreview>(`/invites/${encodeURIComponent(token)}`);
}

export async function acceptInvite(
  token: string,
): Promise<{ project_id: string }> {
  return api.post<{ project_id: string }>(
    `/invites/${encodeURIComponent(token)}/accept`,
    {},
  );
}

export async function sendInvite(
  projectId: ProjectId,
  body: SendInviteRequest,
): Promise<InviteResponse> {
  return api.post<InviteResponse>(`/projects/${projectId}/invites`, body);
}

export async function listInvites(
  projectId: ProjectId,
): Promise<PendingInviteListResponse> {
  return api.get<PendingInviteListResponse>(`/projects/${projectId}/invites`);
}

export async function revokeInvite(
  projectId: ProjectId,
  inviteId: string,
): Promise<void> {
  return api.delete(`/projects/${projectId}/invites/${inviteId}`);
}
